import Vue from 'vue'

const meta = document.head.querySelector('meta[name="api-token"]');
const token = meta ? meta.content : undefined
if (token) {
  Vue.http.interceptors.push(function(request, next) {
    request.headers.set('Authorization', 'Bearer '+token);
    next();
  });
} else {
  console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}


import { createAPI } from 'w3box-vue-api'

import users from './users'
import webpush from './webpush'
import notifications from './notifications'
import traffic from './traffic'

const categories = createAPI('/api/categories')
const clients = createAPI('/api/clients')
const departments = createAPI('/api/departments')
const tasks = createAPI('/api/tasks')
const vacations = createAPI('/api/vacations')

export {
  users,
  webpush,
  notifications,
  categories,
  clients,
  departments,
  tasks,
  traffic,
  vacations,
}